import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
// action creator
import { setAdminTabIndex } from '../../actions/actionCreator';
// utils
import {Translations, convertStringToArray} from '../../../../utils';
// children
import CustomerFilter from './Grid/CustomerFilter';
import ReactTable from './Grid/Table/';
// style
import './style.css'

class CustomerAdmin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: this.props.GridData,
            filterData:[]
        };
        this.grD = [];
    }

    componentDidMount(){
      this.props.setAdminTabIndex(2);
    }

    resetApi = (data) => {
     this.props.resetApiCall(data)
    }

    searchCustomerHandler = (str) => {
      if(str.length > 0 ) {
        let filterobject = this.props.GridData.filter(function(obj) {
            if (typeof obj.fullName !== 'undefined' && obj.fullName.toString().toLowerCase().indexOf(str.toString().toLowerCase()) !== -1 ) {
                return obj;
            }
        });
        this.setState({
          filterData: filterobject,
          data: filterobject
        })
      } else if( str.length === 0){
        this.setState({
          data: this.props.GridData
        })
      }
    }

    searchEmailHandler = (str) => {
      if(str.length > 0 ) {
        let filterobject = this.props.GridData.filter(function(obj) {
            if (typeof obj.email !== 'undefined' && obj.email.toString().toLowerCase().indexOf(str.toString().toLowerCase()) !== -1 ) {
                return obj;
            }
        });
        this.setState({
          filterData: filterobject,
          data: filterobject
        })
      } else if( str.length === 0){
        this.setState({
          data: this.props.GridData
        })
      }
    }

    componentWillReceiveProps(nextProps){
      this.setState({
        data: nextProps.GridData
      })
    }

    columnsHeader = () => {
        let optionsData;
        var options = Translations(this.props.pageJson.table_customerAdmin.fieldLabels,this.props.lang.currentLang.lang, this.props.lang.translatedData);
        var ids = this.props.pageJson.table_customerAdmin.fields;
        optionsData = convertStringToArray(options)
        let columns = []
        ids.map((item, index) => {
          columns.push({
            accessor: item,
            Header: optionsData[index],
            sortable: false
          })
        })
        return columns;
    }

    rowLink =(data) =>{
      if(this.props.rowLinkCustomer){
        this.props.setAdminTabIndex(2);
        this.props.rowLinkCustomer(data)
      }
    }

    resetAll = () => {
      this.setState({
        data: []
      })
      this.props.resetAll()
    }

    route = () => {
      this.props.history.push("/admin-panel/customer-detail/");
    }


    render() {
      return ( this.props.pageJson !== undefined && this.props.GridData !== undefined
          ? (<div>
                <div className="gdoc-caselist-grid">
                  <div className="gdocs-clear-both"></div>
                  <div>
                    <CustomerFilter
                      pageJson={this.props.pageJson}
                      searchCustomerHandler={(str) => this.searchCustomerHandler(str)}
                      searchEmailHandler={(str) => this.searchEmailHandler(str)}
                      serchTitleHeader={this.props.pageJson.table_customerAdmin}
                      resetApiCall={(str) => this.resetApi(str)}
                      clearAll={this.resetAll}
                      clearFilterText={this.props.pageJson.table_customerAdmin.clearFilterText}
                      lang={this.props.lang}
                    />

                    <ReactTable
                      data={this.state.data}
                      pageJsonContent = {this.props.pageJson.table_customerAdmin}
                      columns={this.columnsHeader()}
                      manualPagination={false}
                      isCaseList={true}
                      defaultPageSize={20}
                      rowLink={(data)=> this.rowLink(data)}
                      className="-striped -highlight"
                      lang={this.props.lang}
                      sortable={false}
                    />
                  </div>
                </div>
              </div>)
          : ''
      )
    }
}

const mapDispatchToProps = dispatch => {
  return {
    setAdminTabIndex: index => {
      dispatch(setAdminTabIndex(index))
    }
  }
}

CustomerAdmin.defaultProps = {
    caseSatus: []
}
CustomerAdmin.propTypes = {
    data: PropTypes.array
};

export default connect(null,mapDispatchToProps)(CustomerAdmin)



// WEBPACK FOOTER //
// ./src/components/Admin/AdminPanel/SubComp/CustomerAdmin.js